import * as SearchParams from "search-params";
import * as Peers from "./peers";
import createLog from "./log";
import adapter from "webrtc-adapter";
var log = createLog("bandwidth");
function isFirefox() {
    return adapter.browserDetails.browser === "firefox";
}
function getBitrate() {
    var params = SearchParams.parse(window.location.search.replace(/^\?/, ""));
    var bandwidth = params.find(function (param) { return param.name === "bandwidth"; });
    if (bandwidth && bandwidth.value) {
        log("Will use bandwidth:", +bandwidth.value);
        return +bandwidth.value;
    }
}
function getBitrateByPeersCount() {
    var peersCount = Array.from(Peers.getAll().keys()).length;
    var limit = [
        undefined,
        undefined,
        undefined,
        384,
        256,
        192,
        128,
        128,
        64,
    ][peersCount];
    return limit;
}
export function setMediaBitrate(sdp, media) {
    var lines = sdp.split("\n");
    var line = -1;
    var bitrateWanted = getBitrate() || getBitrateByPeersCount();
    if (!bitrateWanted) {
        log("No bandwidth limit");
        return sdp;
    }
    else {
        log("Limiting bandwidth to", bitrateWanted);
    }
    var lineType = isFirefox() ? "b=TIAS:" : "b=AS:";
    var bitrate = isFirefox() ? bitrateWanted * 1000 : bitrateWanted;
    for (var i = 0; i < lines.length; i++) {
        if (lines[i].indexOf("m=" + media) === 0) {
            line = i;
            break;
        }
    }
    if (line === -1) {
        console.debug("Could not find the m line for", media);
        return sdp;
    }
    console.debug("Found the m line for", media, "at line", line);
    // Pass the m line
    line++;
    // Skip i and c lines
    while (lines[line].indexOf("i=") === 0 || lines[line].indexOf("c=") === 0) {
        line++;
    }
    // If we're on a b line, replace it
    if (lines[line].indexOf("b") === 0) {
        console.debug("Replaced b line at line", line);
        lines[line] = lineType + bitrate;
        return lines.join("\n");
    }
    // Add a new b line
    console.debug("Adding new b line before line", line);
    var newLines = lines.slice(0, line);
    newLines.push(lineType + bitrate);
    newLines = newLines.concat(lines.slice(line, lines.length));
    return newLines.join("\n");
}



//////////////////
// WEBPACK FOOTER
// ./src/bandwidth.ts
// module id = 337
// module chunks = 1